module.exports = __webpack_public_path__ + "img/pdf.42cfb325.png";